import React, { Suspense } from "react";
import "./App.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Loading from "./component/Loading/Loading";

const Error = React.lazy(() => import("./component/Error/Error"));
const SharedLayout = React.lazy(() =>
  import("./pages/SharedLayout/SharedLayout")
);
const Tour = React.lazy(() => import("./pages/Tour/Tour"));
const Substation = React.lazy(() => import("./pages/Substation/Substation"));
const House = React.lazy(() => import("./pages/House/House"));


function App() {
  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <Router>
          <Routes>
            <Route path="/nha-may-dien-gio-nhon-hoi" index element={<Loading />} />
            <Route element={<SharedLayout />}>
              <Route index path="/nha-may-dien-gio-nhon-hoi/tour" element={<Tour />} />
              <Route index path="/nha-may-dien-gio-nhon-hoi/substation" element={<Substation />} />
              <Route index path="/nha-may-dien-gio-nhon-hoi/house" element={<House />} />
            </Route>
            <Route path="*" element={<Error />} />
          </Routes>
        </Router>
      </Suspense>
    </div>
  );
}

export default App;
